import { axiosClient } from "@lib/services/axios";
import { ENDPOINTS } from "@lib/constants/general";
import { AdminLoginParams, LoginParams, LoginResponse } from "@lib/types/login";
import { LinkAccountParams, User } from "@lib/types/users";

export const loginUser = async (
  loginRequest: LoginParams
): Promise<LoginResponse> => {
  const { data } = await axiosClient.post(ENDPOINTS.USER_LOGIN, loginRequest);
  return data;
};

export const loginAdmin = async (
  loginRequest: AdminLoginParams
): Promise<LoginResponse> => {
  const { data } = await axiosClient.post(ENDPOINTS.ADMIN_LOGIN, loginRequest);
  return data;
};

export const linkAccount = async (
  linkAccountParams: LinkAccountParams
): Promise<User> => {
  const { data } = await axiosClient.post(
    ENDPOINTS.USER_LINK_ACCOUNT,
    linkAccountParams
  );
  return data;
};
